// Apple-style scroll-into-view animations.
// - Fade-up reveal for content sections (skips hero, header, footer, marquee).
// - Cascade stagger for repeating-card sections (parent answers, use cases, nav cards).
// Pairs with CSS in assets/base.css (search for ".scroll-fade-up" and ".scroll-cascade").
(function () {
  'use strict';

  const SKIP_ID_PATTERNS = [/hero_/, /marquee_/, /header_/, /footer_/];
  const CASCADE_CHILD_SELECTORS = [
    '.hpa__card',
    '.hnc__card',
    '[class*="ai-quote-columns__column-"]',
    '[class*="ai-stars-card-"]',
    '[class*="ai-numbered-features__item-"]',
    '[class^="ai-feature-card-"]',
  ];
  // Items that should trigger their own reveal (vertically stacked, each
  // gets its own viewport-entry trigger instead of a group cascade).
  const SELF_REVEAL_SELECTORS = ['.huc__row'];
  const FADE_UP_THRESHOLD = 0.12;
  const CASCADE_THRESHOLD = 0.18;

  function isArticleTemplate() {
    const main = document.querySelector('main[data-template]');
    return main?.dataset.template?.split('.')[0] === 'article';
  }

  function shouldSkipSection(section) {
    if (isArticleTemplate()) return true;

    const id = section.id || '';
    if (!id.startsWith('shopify-section-')) return true;
    return SKIP_ID_PATTERNS.some(function (re) { return re.test(id); });
  }

  function tagSections() {
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      if (shouldSkipSection(sec)) return;
      sec.classList.add('scroll-fade-up');
    });
    SELF_REVEAL_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (item) {
        item.classList.add('scroll-self-reveal');
      });
    });
    CASCADE_CHILD_SELECTORS.forEach(function (selector) {
      const items = document.querySelectorAll(selector);
      if (items.length < 2) return;
      const groupsByParent = new Map();
      items.forEach(function (item) {
        const parent = item.parentElement;
        if (!parent) return;
        if (!groupsByParent.has(parent)) groupsByParent.set(parent, []);
        groupsByParent.get(parent).push(item);
      });
      groupsByParent.forEach(function (siblings, parent) {
        if (siblings.length < 2) return;
        parent.classList.add('scroll-cascade-parent');
        siblings.forEach(function (item, i) {
          item.classList.add('scroll-cascade-item');
          item.style.setProperty('--scroll-cascade-index', i);
        });
      });
    });
  }

  function makeObserver(threshold, onEnter) {
    if (!('IntersectionObserver' in window)) {
      return { observe: function (el) { onEnter(el); } };
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          onEnter(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: threshold, rootMargin: '0px 0px -8% 0px' });
    return io;
  }

  function activate() {
    tagSections();

    const fadeUpObs = makeObserver(FADE_UP_THRESHOLD, function (el) {
      el.classList.add('scroll-in');
    });
    document.querySelectorAll('.scroll-fade-up').forEach(function (el) {
      fadeUpObs.observe(el);
    });

    const cascadeObs = makeObserver(CASCADE_THRESHOLD, function (parent) {
      parent.classList.add('scroll-in');
    });
    document.querySelectorAll('.scroll-cascade-parent').forEach(function (el) {
      cascadeObs.observe(el);
    });

    const selfRevealObs = makeObserver(0.2, function (el) {
      el.classList.add('scroll-in');
    });
    document.querySelectorAll('.scroll-self-reveal').forEach(function (el) {
      selfRevealObs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate);
  } else {
    activate();
  }
})();
